import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { toast } from 'react-hot-toast';
import { FiX, FiSend, FiMaximize2, FiMinimize2, FiImage, FiChevronLeft, FiChevronRight, FiPaperclip, FiTrash2 } from 'react-icons/fi';
import apiService from '../services/apiService';
import { useAuth } from '../context/AuthContext';
import { useBranding } from '../context/BrandingContext';
import { paralegalSkryt } from '../utils/paralegalScreen';
import { useLocation, useNavigate } from 'react-router-dom';
import { putQuestion } from '../services/consiliumBridge';
// 🔴 Правило видимости и имя ИИ переехали в config/katifiAccess.js — держатель
//    ОДИН. Здесь копии больше нет: кнопка «Спросить …» верхней полосы обязана
//    показываться ровно тем, кому виден сам виджет (quick-260909-qa3).
import {
    roleNamesOf,
    isCreator as isCreatorRule,
    hasPermission as hasPermissionRule,
    isSuperUser as isSuperUserRule,
    isTenantOwner as isTenantOwnerRule,
    canUseKatifi as canUseKatifiRule,
    canSeeKatifi as canSeeKatifiRule,
    aiName as aiNameRule,
    aiTitle as aiTitleRule,
} from '../config/katifiAccess';
import { razbitNaKuski } from '../utils/razmetka';
import './KatifiWidget.css';

const KatifiWidget = () => {
    const { user, isAuthenticated } = useAuth();
    /* 🔴 ПИЛЮЛЯ — ТОЛЬКО У fitenko, И ГЕЙТ ЖИВЁТ В РАЗМЕТКЕ, А НЕ В ОБЩЕМ CSS.
       Первая редакция прятала метку правилом .katifi-fab-label{display:none} в
       KatifiWidget.css — правилом ВНЕ рубежа арендатора. Сторож
       verify_fitenko_rail_typography.py покраснел сразу (П1б, П3г: «правил вне
       рубежа было 2527, стало 2528»): храповик цены общего бандла стоит без
       запаса. Гейт в разметке стоит ноль правил, и разметка остальных трёх
       арендаторов остаётся ПОБАЙТОВО прежней.                                */
    const { isFitenko, features } = useBranding();
    const location = useLocation();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [katifiMessages, setKatifiMessages] = useState([]);
    const [katifiInput, setKatifiInput] = useState('');
    const [katifiLoading, setKatifiLoading] = useState(false);
    const [hasUnread, setHasUnread] = useState(false);
    const [proactiveMessage, setProactiveMessage] = useState('');
    
    // Gallery & Lightbox State
    const [isGalleryOpen, setIsGalleryOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [galleryImages, setGalleryImages] = useState([]);
    const [hiddenImages, setHiddenImages] = useState([]);
    const [vaultUnlocked, setVaultUnlocked] = useState(false);
    const [activeTab, setActiveTab] = useState('regular'); // 'regular' or 'secret'
    const [secretVideos, setSecretVideos] = useState([]); // NEW: AI-generated videos
    
    // Manus Mode
    const [isManusMode, setIsManusMode] = useState(false);
    const [manusLogs, setManusLogs] = useState([]);
    const [manusTerminalOpen, setManusTerminalOpen] = useState(false);
    const [manusSessionId, setManusSessionId] = useState(`session_${Date.now()}`);
    
    // Cloud Image Provider Toggle
    const [useFalAi, setUseFalAi] = useState(() => {
        const stored = localStorage.getItem('katifi_use_fal_ai');
        return stored === 'true';
    });
    const handleFalToggle = () => {
        const newVal = !useFalAi;
        setUseFalAi(newVal);
        localStorage.setItem('katifi_use_fal_ai', newVal.toString());
    };

    // Uncensored Mode Toggle
    const [useUncensoredMode, setUseUncensoredMode] = useState(() => {
        const stored = localStorage.getItem('katifi_use_uncensored');
        return stored === 'true';
    });
    const handleUncensoredToggle = () => {
        const newVal = !useUncensoredMode;
        setUseUncensoredMode(newVal);
        localStorage.setItem('katifi_use_uncensored', newVal.toString());
    };

    // Image attachment state
    const [attachmentBase64, setAttachmentBase64] = useState(null);
    const [attachmentMimeType, setAttachmentMimeType] = useState(null);
    const [attachmentPreview, setAttachmentPreview] = useState(null);
    const fileInputRef = useRef(null);
    const formRef = useRef(null);

    // FLUX Ultra Photo polling state
    const fluxPollRefs = useRef({});

    useEffect(() => {
        return () => {
            Object.values(fluxPollRefs.current).forEach(clearInterval);
        };
    }, []);

    const startFluxPolling = (taskId, messageIndex) => {
        let pollCount = 0;
        const maxPolls = 48; // 8 minutes at 10s intervals
        const endpoint = canUseKatifi ? '/admin/katifi/flux-status/' : '/admin/julifi/flux-status/';

        const intervalId = setInterval(async () => {
            pollCount++;
            try {
                const data = await apiService.makeRequest(endpoint + taskId);
                if (data.status === 'completed' && data.image_url) {
                    clearInterval(intervalId);
                    delete fluxPollRefs.current[taskId];
                    setKatifiMessages(prev => prev.map((msg, idx) => {
                        if (idx === messageIndex && msg.role === 'model') {
                            const cleaned = msg.content
                                .replace(/\[FLUX_TASK_ID:[a-f0-9-]+\]/g, '')
                                .replace(/\*\(⏳.*?автоматически\.\)\*/g, '');
                            return { ...msg, content: cleaned + `\n\n![Ultra Photo](${data.image_url})` };
                        }
                        return msg;
                    }));
                } else if (data.status === 'failed') {
                    clearInterval(intervalId);
                    delete fluxPollRefs.current[taskId];
                    setKatifiMessages(prev => prev.map((msg, idx) => {
                        if (idx === messageIndex && msg.role === 'model') {
                            return { ...msg, content: msg.content.replace(/\[FLUX_TASK_ID:[a-f0-9-]+\]/g, '') + '\n\n*(❌ Ультра-рендер не удался. Попробуйте ещё раз.)*' };
                        }
                        return msg;
                    }));
                }
            } catch (err) {
                // Polling error, continue trying
            }
            if (pollCount >= maxPolls) {
                clearInterval(intervalId);
                delete fluxPollRefs.current[taskId];
            }
        }, 10000);

        fluxPollRefs.current[taskId] = intervalId;
    };

    // Auto-scroll
    const messagesEndRef = useRef(null);

    // 1. Permission Check — ПРАВИЛО ЖИВЁТ В config/katifiAccess.js, здесь только
    // его применение. Прежние выражения перенесены туда дословно; сверка нового
    // правила с замороженным телом прежнего — ворота В5 задачи 4.
    // roleNames остаётся: он нужен приветствию (:196), а не правилу видимости.
    // Берётся из ТОГО ЖЕ держателя, а не собирается второй раз руками.
    const roleNames = roleNamesOf(user);
    const isCreator = isCreatorRule(user);
    const hasPermission = hasPermissionRule(user);
    const isSuperUser = isSuperUserRule(user);
    const isTenantOwner = isTenantOwnerRule(user);
    const canUseKatifi = canUseKatifiRule(user);
    const canSeeKatifi = canSeeKatifiRule(user);

    // Fetch real gallery
    useEffect(() => {
        if (!user || (!isCreator && !hasPermission && !isSuperUser)) return;
        
        const fetchGallery = async () => {
            try {
                if (isCreator || isSuperUser) { // Currently fetching Katifi only
                    const response = await apiService.makeRequest('/admin/katifi/flux-gallery');
                    if (response && response.status === 'success') {
                        setGalleryImages(response.regular.map(img => img.url));
                        setHiddenImages(response.hidden.map(img => img.url));
                    }
                }
            } catch (err) {
                console.error("Failed to fetch Katifi gallery", err);
            }
        };
        fetchGallery();

        // [NEW] Fetch secret video archive
        const fetchVideos = async () => {
            try {
                if (isCreator || isSuperUser) {
                    const vRes = await apiService.makeRequest('/admin/katifi/videos?limit=50');
                    if (vRes && vRes.videos) setSecretVideos(vRes.videos);
                }
            } catch (err) { console.error('Video archive fetch failed', err); }
        };
        fetchVideos();
    }, [user, isCreator, hasPermission, isSuperUser, isOpen]);

    const aiName = aiNameRule(user);
    const aiTitle = aiTitleRule(user);
    
    const [customAvatar, setCustomAvatar] = useState(null);
    useEffect(() => {
        const stored = localStorage.getItem(`customAvatar_${user?.email}_${aiName}`);
        if(stored) setCustomAvatar(stored);
    }, [user, aiName]);

    const defaultAvatar = canUseKatifi ? '/katifi-avatar.png' : 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=600&auto=format&fit=crop';
    const aiAvatar = customAvatar || defaultAvatar;


    // Initialize Greeting
    useEffect(() => {
        if (!user) return;
        
        let title = "Сотрудник";
        if (user.email === "afitbk@gmail.com") {
            title = "Создатель";
        } else if (roleNames.includes('ADMINISTRATOR') || roleNames.includes('ADMIN')) {
            title = "Директор";
        } else if (user.first_name) {
            title = user.first_name;
        }

        let initialMessage = canUseKatifi
            ? `Здравствуйте, ${title}. Я Катифи — ваш личный помощник. Чем могу помочь вам сегодня в вашей работе?`
            : `Здравствуйте, ${title}. Я Джулифи — ваш личный помощник. Чем могу помочь вам сегодня в вашей работе?`;
        
        if (user.first_name && (user.first_name.toLowerCase() === "russel" || user.first_name.toLowerCase() === "russell")) {
            initialMessage = `Hello, ${title}. I am Julifi, your personal assistant. How may I assist you with your work today?`;
        }

        setKatifiMessages([
            { role: 'model', content: initialMessage }
        ]);
        
        // Fetch Proactive Unread Messages
        const fetchProactive = async () => {
            try {
                const endpoint = canUseKatifi ? '/admin/katifi/messages/unread' : '/admin/julifi/messages/unread';
                const res = await apiService.makeRequest(endpoint);
                if (res && res.message) {
                    setProactiveMessage(res.message);
                    setHasUnread(true);
                    setKatifiMessages(prev => [...prev, { role: 'model', content: res.message }]);
                } else {
                    // Fallback generic prompt
                    setTimeout(() => {
                        setProactiveMessage("У меня есть новые отчеты от Агентов, хотите взглянуть?");
                        setHasUnread(true);
                    }, 2500);
                }
            } catch (err) {
                setTimeout(() => {
                    setProactiveMessage("Доброе утро! Агенты ждут ваших указаний.");
                    setHasUnread(true);
                }, 2500);
            }
        };
        fetchProactive();

    }, [user, isCreator]);

    // Scroll to bottom
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    useEffect(() => {
        if (isOpen) {
            scrollToBottom();
            setHasUnread(false);
        }
    }, [katifiMessages, isOpen, isExpanded]);

    // Global listener for Manus triggering — opens widget, enables Manus mode, and auto-submits
    useEffect(() => {
        const handleLaunchManus = (e) => {
            const command = e.detail?.command;
            if (command) {
                setIsOpen(true);
                setIsExpanded(true);
                setIsManusMode(true);
                // Fill input after widget has expanded, then auto-submit via form
                setTimeout(() => {
                    setKatifiInput(command);
                    // Give React one more tick to flush the input state before submitting
                    setTimeout(() => {
                        formRef.current?.requestSubmit();
                    }, 50);
                }, 350);
            }
        };
        window.addEventListener('launchKatifiManus', handleLaunchManus);
        return () => window.removeEventListener('launchKatifiManus', handleLaunchManus);
    }, []);

    // Кнопка «Спросить …» верхней полосы: ОТКРЫТЬ окно и ЗАМОЛЧАТЬ.
    // 🔴 Соседний launchKatifiManus для этого НЕ ГОДИТСЯ: он требует
    //    detail.command, включает режим Manus и через ~400 мс САМ ОТПРАВЛЯЕТ
    //    запрос. Кнопка, говорящая за человека, — это не кнопка «спросить».
    // 🔴 СОБЫТИЕ НАУЧИЛОСЬ НЕСТИ ТЕМУ (quick-260911-1lx). `detail.tekst`
    //    ЗАПОЛНЯЕТ поле ввода и ЗАМОЛЧИВАЕТ: отправляет по-прежнему человек.
    //    Довод «почему не launchKatifiManus» записан ВЫШЕ и здесь не
    //    пересказывается — пересказ разошёлся бы с оригиналом.
    //    🔴 Виджет ОБЩИЙ для четырёх арендаторов, поэтому ветка добавлена так,
    //    чтобы событие БЕЗ `detail` вело себя ПОСИМВОЛЬНО как прежде: у
    //    mlg/eln/elfny событие с темой не шлёт никто, и это доказано
    //    исполнением обработчика обоими способами (`katifi-detail-proba.mjs`),
    //    а не обещано.
    useEffect(() => {
        const handleOpen = (e) => {
            setIsOpen(true);
            const tekst = e && e.detail && e.detail.tekst;
            if (typeof tekst === 'string' && tekst.trim()) {
                setKatifiInput(tekst);
            }
        };
        window.addEventListener('katifi:open', handleOpen);
        return () => window.removeEventListener('katifi:open', handleOpen);
    }, []);

    /* 🔴 ПРИЗНАК ВИДИМОСТИ — ОДИН ДЕРЖАТЕЛЬ на два потребителя: ранний возврат
       ниже и метка на корне документа. Два списка условий разошлись бы молча.  */
    const vidimWidget = isAuthenticated && canSeeKatifi && location.pathname !== '/admin/brain';

    /* 🔴 СДВИГ СОДЕРЖИМОГО ЖИВЁТ НА КОРНЕ ДОКУМЕНТА, А НЕ НА САМОМ ВИДЖЕТЕ.
       Виджет смонтирован СОСЕДОМ .App (App.js:207, ProtectedLayout) — изнутри
       себя он до .App не дотянется ни одним селектором. Метка кладётся на
       <html>, где рубеж арендатора html.fitenko уже стоит.
       🔴 Снимается метка и по vidimWidget: иначе уход на /admin/brain оставил
       бы содержимое сдвинутым при отсутствующей панели — отступ без панели
       есть ровно [[knowledge_decorative_flag]] наоборот.                      */
    useEffect(() => {
        const koren = document.documentElement;
        koren.classList.toggle('katifi-panel-open', vidimWidget && isOpen);
        koren.classList.toggle('katifi-panel-wide', vidimWidget && isOpen && isExpanded);
        return () => {
            koren.classList.remove('katifi-panel-open');
            koren.classList.remove('katifi-panel-wide');
        };
    }, [vidimWidget, isOpen, isExpanded]);

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            toast.error('Only images are supported');
            return;
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            setAttachmentBase64(reader.result);   // data:image/...;base64,...
            setAttachmentMimeType(file.type);
            setAttachmentPreview(reader.result);
        };
        reader.readAsDataURL(file);
        // reset input so same file can be re-selected
        e.target.value = '';
    };

    const clearAttachment = () => {
        setAttachmentBase64(null);
        setAttachmentMimeType(null);
        setAttachmentPreview(null);
    };

    const handleKatifiSubmit = async (e) => {
        e?.preventDefault();
        if ((!katifiInput.trim() && !attachmentBase64) || katifiLoading) return;

        const newUserMsg = {
            role: 'user',
            content: katifiInput.trim() || '(Прислал фото для анализа)',
            ...(attachmentBase64 && { image_base64: attachmentBase64, mime_type: attachmentMimeType })
        };
        const updatedMessages = [...katifiMessages, newUserMsg];

        setKatifiMessages(updatedMessages);
        setKatifiInput('');
        clearAttachment();
        setKatifiLoading(true);

        try {
            if (isManusMode && isCreator) {
                // Katifi-Design Autonomy Execution
                setManusTerminalOpen(true);
                setManusLogs([{ step: 'Initialization', details: `Request received: ${katifiInput}` }]);
                
                const response = await fetch('/api/v1/admin/katifi/manus/execute', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include',
                    body: JSON.stringify({ command: katifiInput, session_id: manusSessionId })
                });

                if (!response.ok) throw new Error(`Manus Endpoint Error: ${response.status}`);

                const reader = response.body.getReader();
                const decoder = new TextDecoder();
                let isComplete = false;
                
                while (!isComplete) {
                    const { value, done } = await reader.read();
                    if (done) {
                        if (!isComplete) {
                            setManusLogs(prev => [...prev, {step: 'Error', details: 'Stream disconnected unexpectedly.'}]);
                            setKatifiMessages(prev => [...prev, {role: 'model', content: `[MANUS FAIL] Соединение разорвано до завершения генерации. (Возможно, таймаут Nginx > 60c). Пожалуйста, попросите Katifi проверить статус сайта или запустите задачу заново.`}]);
                        }
                        isComplete = true; // explicitly end the loop state
                        break;
                    }
                    const chunk = decoder.decode(value, { stream: true });
                    const lines = chunk.split('\n');
                    for (const line of lines) {
                        if (line.startsWith('data: ')) {
                            const dataStr = line.substring(6).trim();
                            if(!dataStr) continue;
                            try {
                                const data = JSON.parse(dataStr);
                                if (data.type === 'complete') {
                                    isComplete = true;
                                    const baseUrl = process.env.REACT_APP_API_URL || 'https://mlg.nygot.com/api/v1';
                                    const previewUrl = data.url ? (baseUrl.replace('/api/v1', '') + data.url) : null;
                                    const screenshotUrl = data.screenshot ? (baseUrl.replace('/api/v1', '') + data.screenshot) : null;
                                    setKatifiMessages(prev => [
                                        ...prev,
                                        {
                                            role: 'model',
                                            content: `**[MANUS] Сайт собран и протестирован!** ✅\n\n🔗 [Открыть превью](${previewUrl})\n\nСкриншот готового сайта:\n![Скриншот](${screenshotUrl || ''})`,
                                            manus_preview_url: previewUrl
                                        }
                                    ]);
                                } else if (data.type === 'log') {
                                    setManusLogs(prev => [...prev, {step: data.step, details: data.details}]);
                                } else if (data.type === 'error') {
                                    setKatifiMessages(prev => [...prev, {role: 'model', content: `[MANUS FAIL] ${data.details}`}]);
                                    isComplete = true;
                                }
                            } catch(e) {}
                        }
                    }
                }
                
                setTimeout(() => setManusTerminalOpen(false), 3000);
            } else {
                // Standard Katifi/Julifi Logic
                const endpoint = canUseKatifi ? '/admin/katifi/chat' : '/admin/julifi/chat';
                const data = await apiService.makeRequest(endpoint, {
                    method: 'POST',
                    body: JSON.stringify({ 
                        messages: updatedMessages,
                        image_provider: useFalAi ? 'fal_ai' : 'vision_node',
                        uncensored_mode: useUncensoredMode
                    })
                });

            let responseText = data.response || "";
            const avatarMatch = responseText.match(/\[SET_AVATAR=(.+?)\]/);
            if (avatarMatch) {
               const newAvatar = avatarMatch[1].replace(')', '').trim();
               setCustomAvatar(newAvatar);
               localStorage.setItem(`customAvatar_${user?.email}_${aiName}`, newAvatar);
               responseText = responseText.replace(/\[SET_AVATAR=.+?\]/g, "").trim();
            }

            /* К ответу привязывается текст ТОГО САМОГО сообщения пользователя, а
               не «последнего вопроса»: пока идёт ответ, человек успевает
               написать следующий, и кнопка увела бы в консилиум чужой вопрос. */
            const newMessages = [
                ...updatedMessages,
                { role: 'model', content: responseText, question: newUserMsg.content }
            ];
            setKatifiMessages(newMessages);

            // Check for FLUX ultra task ID and start polling
            const fluxMatch = responseText.match(/\[FLUX_TASK_ID:([a-f0-9-]+)\]/);
            if (fluxMatch) {
                const taskId = fluxMatch[1];
                const messageIdx = newMessages.length - 1;
                startFluxPolling(taskId, messageIdx);
            }

            if (!isOpen) setHasUnread(true);
            } // Close the initial 'try {} else {} block' for Manus Mode
        } catch (err) {
            console.error("Katifi Chat API Error:", err);
            toast.error("Neural connection lost");
            setKatifiMessages([...updatedMessages, { role: 'model', content: "⚠️ Warning: Neural link severed. Please check system diagnostics." }]);
        } finally {
            setKatifiLoading(false);
            if (!manusTerminalOpen) {
                 setTimeout(scrollToBottom, 100);
            }
        }
    };

    const toggleOpen = () => {
        setIsOpen(!isOpen);
        if (!isOpen) setHasUnread(false);
    };

    if (!vidimWidget) return null;

    // Отрисовка ответа: разбор разметки живёт в utils/razmetka.js (держатель
    // ОДИН на оба виджета, quick-260912-4cp), здесь остаётся только укладка
    // кусков в JSX. Теги, классы и поведение картинок/видео — те же, что были.
    const renderKatifiMessage = (text) => {
        if (!text) return null;
        const kuski = razbitNaKuski(text);
        if (kuski.length === 0) return text;
        return kuski.map((kusok, i) => {
            if (kusok.tip === 'video') {
                return (
                    <video
                        key={`vid-${i}`}
                        src={kusok.url}
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{ maxWidth: '100%', borderRadius: '8px', marginTop: '10px', marginBottom: '10px', display: 'block' }}
                        className="katifi-inline-vid"
                    />
                );
            }
            if (kusok.tip === 'img') {
                return (
                    <img
                        key={`img-${i}`}
                        src={kusok.url}
                        alt={kusok.alt}
                        style={{ maxWidth: '100%', borderRadius: '8px', marginTop: '10px', marginBottom: '10px', display: 'block', cursor: 'zoom-in' }}
                        onClick={() => setSelectedImage(kusok.url)}
                        className="katifi-inline-img"
                    />
                );
            }
            // kusok.html уже санитизирован внутри razmetka.js — второй ручки,
            // отдающей несанитизированный HTML, у модуля нет по построению.
            return <span key={`text-${i}`} dangerouslySetInnerHTML={{ __html: kusok.html }} />;
        });
    };

    // Lightbox navigation
    const getActiveGalleryArray = () => {
        if (galleryImages.includes(selectedImage)) return galleryImages;
        if (hiddenImages.includes(selectedImage)) return hiddenImages;
        return [];
    };

    const handlePrevImage = (e) => {
        e.stopPropagation();
        const arr = getActiveGalleryArray();
        if (arr.length === 0) return;
        const idx = arr.indexOf(selectedImage);
        if (idx > 0) setSelectedImage(arr[idx - 1]);
        else setSelectedImage(arr[arr.length - 1]);
    };

    const handleNextImage = (e) => {
        e.stopPropagation();
        const arr = getActiveGalleryArray();
        if (arr.length === 0) return;
        const idx = arr.indexOf(selectedImage);
        if (idx !== -1 && idx < arr.length - 1) setSelectedImage(arr[idx + 1]);
        else setSelectedImage(arr[0]);
    };

    const handleDeleteImage = async (e) => {
        e.stopPropagation();
        if (!window.confirm("Delete this photo forever?")) return;
        try {
            await apiService.makeRequest('/admin/katifi/photo', {
                method: 'DELETE',
                body: JSON.stringify({ url: selectedImage })
            });
            setGalleryImages(prev => prev.filter(i => i !== selectedImage));
            setHiddenImages(prev => prev.filter(i => i !== selectedImage));
            setSelectedImage(null);
            toast.success("Photo deleted");
        } catch (err) {
            toast.error("Failed to delete photo");
        }
    };

    /* FULLSCREEN IMAGE LIGHTBOX — portal to document.body escapes widget's
       CSS transform stacking context so position:fixed works correctly    */
    const lightboxPortal = selectedImage
        ? ReactDOM.createPortal(
            <div
                className="katifi-lightbox"
                onClick={() => setSelectedImage(null)}
                style={{ position: 'fixed', inset: 0, zIndex: 999999,
                         background: 'rgba(0,0,0,0.92)',
                         display: 'flex', alignItems: 'center', justifyContent: 'center',
                         flexDirection: 'column', gap: '16px' }}
            >
                <div
                    className="katifi-lightbox-close"
                    style={{ position: 'absolute', top: '20px', right: '24px',
                             cursor: 'pointer', color: '#fff', fontSize: '28px' }}
                >
                    <FiX />
                </div>
                
                {getActiveGalleryArray().length > 1 && (
                    <>
                        <div onClick={handlePrevImage} style={{ position: 'absolute', left: '20px', top: '50%', transform: 'translateY(-50%)', color: '#fff', fontSize: '40px', cursor: 'pointer', padding: '20px' }}>
                            <FiChevronLeft />
                        </div>
                        <div onClick={handleNextImage} style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', color: '#fff', fontSize: '40px', cursor: 'pointer', padding: '20px' }}>
                            <FiChevronRight />
                        </div>
                    </>
                )}

                <img
                    src={selectedImage}
                    alt="Enlarged view"
                    className="katifi-lightbox-img"
                    onClick={(e) => e.stopPropagation()}
                    style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: '12px',
                             objectFit: 'contain', boxShadow: '0 8px 48px rgba(0,0,0,0.6)' }}
                />
                
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center', zIndex: 1000000 }} onClick={(e) => e.stopPropagation()}>
                    <a
                        href={selectedImage.startsWith('/api/') ? `${window.location.origin}${selectedImage}` : selectedImage}
                        download
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: '#fff', background: 'rgba(255,255,255,0.15)',
                                 padding: '8px 20px', borderRadius: '8px',
                                 textDecoration: 'none', fontSize: '14px', backdropFilter: 'blur(4px)' }}
                    >
                        ⬇ Download
                    </a>
                    <button
                        onClick={handleDeleteImage}
                        style={{ color: '#fca5a5', background: 'rgba(239, 68, 68, 0.2)', border: '1px solid rgba(239, 68, 68, 0.5)',
                                 padding: '8px 20px', borderRadius: '8px', cursor: 'pointer',
                                 display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', backdropFilter: 'blur(4px)' }}
                    >
                        <FiTrash2 /> Delete
                    </button>
                </div>
            </div>,
            document.body
          )
        : null;

    return (
        <>
            <div className={`katifi-widget-container ${isOpen ? 'open' : 'closed'} ${isExpanded ? 'expanded' : ''}`}>
                {/* FLOATING ACTION BUTTON & BUBBLE */}
                {!isOpen && (
                    <div className="katifi-fab-wrapper">
                        {hasUnread && proactiveMessage && (
                            <div className="katifi-proactive-bubble" onClick={toggleOpen}>
                                <div className="proactive-header">
                                    <span className="proactive-name">{aiName.split(' ')[0]}</span>
                                    <span className="proactive-time">New</span>
                                </div>
                                <div className="proactive-text">
                                    {proactiveMessage.length > 80 ? proactiveMessage.substring(0, 80) + '...' : proactiveMessage}
                                </div>
                                <div className="proactive-arrow"></div>
                            </div>
                        )}
                        {/* Метка имени — часть ПИЛЮЛИ, и она ЕСТЬ ТОЛЬКО У fitenko.
                            У mlg / eln / elfny свёрнутое состояние остаётся прежней
                            круглой кнопкой: ни одного лишнего узла, ни одного
                            правила в общем бандле (quick-260911-28w). */}
                        <button className="katifi-fab" onClick={toggleOpen} aria-label={`Open ${aiName}`}>
                            <img src={aiAvatar} alt={aiName} className="katifi-fab-img" style={{ objectFit: 'cover' }} />
                            {isFitenko && <span className="katifi-fab-label">{aiName.split(' ')[0]}</span>}
                            {hasUnread && <span className="katifi-fab-badge">1</span>}
                        </button>
                    </div>
                )}

                {/* CHAT WINDOW */}
                {isOpen && (
                    <div className="katifi-chat-window">
                        <div className="katifi-chat-header">
                            <div className="katifi-header-left" onClick={() => setIsGalleryOpen(true)} style={{ cursor: 'pointer' }} title={`View ${aiName}'s Profile`}>
                                <img src={aiAvatar} alt={aiName} className="katifi-header-img" style={{ objectFit: 'cover' }} />
                                <div className="katifi-header-text">
                                    <h3>{aiName}</h3>
                                    <p>{aiTitle}</p>
                                </div>
                            </div>
                            <div className="katifi-header-right">
                                <label className="katifi-fal-toggle" title="Включить быструю генерацию fal.ai (вместо Mac Mini)">
                                    <span className="katifi-fal-label">⚡</span>
                                    <input type="checkbox" checked={useFalAi} onChange={handleFalToggle} />
                                    <span className="katifi-fal-slider"></span>
                                </label>
                                {isCreator && (
                                    <>
                                        <button 
                                            onClick={() => setIsManusMode(!isManusMode)} 
                                            className={`katifi-header-btn ${isManusMode ? 'manus-active' : ''}`}
                                            title="Autonomy Mode: Manus/Devin Engine"
                                            style={isManusMode ? { color: '#00f2fe', background: 'rgba(0, 242, 254, 0.1)', border: '1px solid currentColor' } : {}}
                                        >
                                            🧠
                                        </button>
                                        <button 
                                            onClick={handleUncensoredToggle} 
                                            className={`katifi-header-btn ${useUncensoredMode ? 'manus-active' : ''}`}
                                            title="Отключить цензуру (Темный Мозг)"
                                            style={useUncensoredMode ? { color: '#ef4444', background: 'rgba(239, 68, 68, 0.1)', border: '1px solid currentColor' } : { color: '#94a3b8' }}
                                        >
                                            ★
                                        </button>
                                    </>
                                )}
                                <button onClick={() => setIsGalleryOpen(!isGalleryOpen)} className="katifi-header-btn" title="Photo Gallery">
                                    <FiImage />
                                </button>
                                <button onClick={() => setIsExpanded(!isExpanded)} className="katifi-header-btn">
                                    {isExpanded ? <FiMinimize2 /> : <FiMaximize2 />}
                                </button>
                                <button onClick={toggleOpen} className="katifi-header-btn close-btn">
                                    <FiX />
                                </button>
                            </div>
                        </div>

                        <div className="katifi-chat-body">
                            {katifiMessages.map((msg, idx) => (
                                <div key={idx} className={`katifi-msg-wrapper ${msg.role === 'user' ? 'user' : 'model'}`}>
                                    {msg.role === 'model' && (
                                        <img
                                            src={aiAvatar}
                                            alt={aiName}
                                            className="katifi-msg-avatar-img clickable-avatar"
                                            style={{ objectFit: 'cover' }}
                                            onClick={() => setSelectedImage(aiAvatar)}
                                            title="Click to enlarge"
                                        />
                                    )}
                                    <div className={`katifi-msg-bubble ${msg.role === 'user' ? 'user' : 'model'}`} style={{ whiteSpace: msg.role === 'user' ? 'pre-wrap' : 'normal' }}>
                                        {msg.image_base64 && (
                                            <img
                                                src={msg.image_base64}
                                                alt="Attachment"
                                                style={{ maxWidth: '100%', borderRadius: '8px', display: 'block', marginBottom: '6px', cursor: 'zoom-in' }}
                                                onClick={() => setSelectedImage(msg.image_base64)}
                                            />
                                        )}
                                        {renderKatifiMessage(msg.content)}
                                        {/* Медленная полоса. Быстрый ответ уже дан выше;
                                            кнопка есть только под ПОСЛЕДНИМ ответом и только
                                            когда вопрос к нему известен — иначе в консилиум
                                            уехало бы пусто. */}
                                        {msg.role === 'model' && msg.question && canUseKatifi && !paralegalSkryt(features)
                                            && idx === katifiMessages.length - 1 && (
                                            <button
                                                type="button"
                                                className="katifi-consilium-btn"
                                                onClick={() => {
                                                    putQuestion(msg.question);
                                                    setIsOpen(false);
                                                    navigate('/ai-paralegal');
                                                }}
                                                title="Разобрать вопрос консилиумом (идёт минутами)"
                                            >
                                                ⚖️ Собрать консилиум по этому вопросу
                                            </button>
                                        )}
                                    </div>
                                </div>
                            ))}
                            {katifiLoading && (
                                <div className="katifi-msg-wrapper model">
                                    <img src={aiAvatar} alt={aiName} className="katifi-msg-avatar-img" style={{ objectFit: 'cover' }} />
                                    <div className="katifi-msg-bubble model typing">
                                        <div className="typing-dot"></div>
                                        <div className="typing-dot"></div>
                                        <div className="typing-dot"></div>
                                    </div>
                                </div>
                            )}
                            
                            {/* Manus Terminal Overlay */}
                            {manusTerminalOpen && (
                                <div className="katifi-manus-terminal">
                                    <div className="manus-terminal-header">
                                        <span className="manus-terminal-dot red"></span>
                                        <span className="manus-terminal-dot yellow"></span>
                                        <span className="manus-terminal-dot green"></span>
                                        <span className="manus-terminal-title">Katifi-Design execution log</span>
                                    </div>
                                    <div className="manus-terminal-body">
                                        {manusLogs.map((log, i) => (
                                            <div key={i} className="manus-log-line">
                                                <span className="manus-time">[{new Date().toLocaleTimeString()}]</span>
                                                <span className="manus-step">[{log.step}]</span>
                                                <span className="manus-detail">{log.details}</span>
                                            </div>
                                        ))}
                                        <div className="manus-typing-cursor">_</div>
                                    </div>
                                </div>
                            )}
                            <div ref={messagesEndRef} />
                        </div>

                        <div className="katifi-chat-footer">
                            {/* Attachment preview */}
                            {attachmentPreview && (
                                <div style={{ padding: '6px 12px', background: '#f1f5f9', borderTop: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <img src={attachmentPreview} alt="attach" style={{ height: '48px', borderRadius: '6px', objectFit: 'cover', border: '1px solid #cbd5e1' }} />
                                    <span style={{ fontSize: '11px', color: '#64748b', flex: 1 }}>Фото готово для анализа</span>
                                    <button onClick={clearAttachment} style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: '50%', width: '18px', height: '18px', fontSize: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', flexShrink: 0 }}>×</button>
                                </div>
                            )}
                            <form onSubmit={handleKatifiSubmit} className="katifi-input-form" ref={formRef}>
                                {/* Hidden file input */}
                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={fileInputRef}
                                    onChange={handleFileSelect}
                                    style={{ display: 'none' }}
                                />
                                {/* Attach button */}
                                <button
                                    type="button"
                                    onClick={() => fileInputRef.current?.click()}
                                    disabled={katifiLoading}
                                    title="Прикрепить фото"
                                    style={{ background: attachmentBase64 ? '#eff6ff' : 'transparent', border: 'none', borderRadius: '50%', width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: katifiLoading ? 'not-allowed' : 'pointer', color: attachmentBase64 ? '#2563eb' : '#94a3b8', flexShrink: 0, fontSize: '16px' }}
                                >
                                    <FiPaperclip />
                                </button>
                                <input
                                    type="text"
                                    placeholder={attachmentBase64 ? 'Что проанализировать?' : `Ask ${aiName.split(' ')[0]}...`}
                                    value={katifiInput}
                                    onChange={(e) => setKatifiInput(e.target.value)}
                                    disabled={katifiLoading}
                                />
                                <button type="submit" disabled={(!katifiInput.trim() && !attachmentBase64) || katifiLoading}>
                                    <FiSend />
                                </button>
                            </form>
                        </div>

                        {/* GALLERY OVERLAY */}
                        {isGalleryOpen && (
                            <div className="katifi-gallery-overlay">
                                <div className="katifi-gallery-header">
                                    <button className="katifi-back-btn" onClick={() => setIsGalleryOpen(false)}>
                                        <FiChevronLeft /> Назад
                                    </button>
                                </div>
                                <div className="katifi-gallery-profile">
                                    <img
                                        src={aiAvatar}
                                        alt={`${aiName} Large`}
                                        style={{ objectFit: 'cover' }}
                                        className="katifi-profile-large"
                                        onClick={() => setSelectedImage(aiAvatar)}
                                        onDoubleClick={() => setVaultUnlocked(true)}
                                        title="Double click to unlock..."
                                    />
                                    <h2>{aiName}</h2>
                                    <p>{aiTitle}</p>
                                </div>
                                
                                {vaultUnlocked && (
                                    <div className="katifi-gallery-tabs" style={{ display: 'flex', justifyContent: 'center', gap: '15px', marginBottom: '15px' }}>
                                        <button 
                                            onClick={() => setActiveTab('regular')} 
                                            style={{ background: activeTab === 'regular' ? '#2563eb' : 'transparent', color: activeTab === 'regular' ? '#fff' : '#64748b', border: '1px solid #cbd5e1', padding: '4px 12px', borderRadius: '15px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }}
                                        >ГАЛЕРЕЯ</button>
                                        <button 
                                            onClick={() => setActiveTab('secret')} 
                                            style={{ background: activeTab === 'secret' ? '#ef4444' : 'transparent', color: activeTab === 'secret' ? '#fff' : '#ef4444', border: '1px solid #ef4444', padding: '4px 12px', borderRadius: '15px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }}
                                        >СЕКРЕТНЫЙ АРХИВ</button>
                                    </div>
                                )}

                                <div className="katifi-gallery-grid" style={activeTab === 'secret' ? { background: '#0f172a', padding: '10px', borderRadius: '8px' } : {}}>
                                    {activeTab === 'secret' ? (
                                        <>
                                            {/* Secret Videos first */}
                                            {secretVideos.map((v, idx) => (
                                                <div key={`vid-${idx}`} className="gallery-thumbnail-wrapper" style={{ position: 'relative' }}>
                                                    <video
                                                        src={v.url.startsWith('http') ? v.url : `https://mlg.nygot.com${v.url}`}
                                                        muted
                                                        loop
                                                        playsInline
                                                        style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px', cursor: 'pointer', display: 'block', filter: 'saturate(1.1) contrast(1.05)' }}
                                                        onMouseEnter={e => e.target.play()}
                                                        onMouseLeave={e => { e.target.pause(); e.target.currentTime = 0; }}
                                                        onClick={() => setSelectedImage(v.url.startsWith('http') ? v.url : `https://mlg.nygot.com${v.url}`)}
                                                        preload="metadata"
                                                    />
                                                    <span style={{ position: 'absolute', top: 4, right: 4, background: 'rgba(0,0,0,0.6)', borderRadius: 4, fontSize: 10, color: '#e0e7ff', padding: '2px 5px' }}>🎬 VIDEO</span>
                                                </div>
                                            ))}
                                            {/* Then hidden photos */}
                                            {hiddenImages.map((src, idx) => (
                                                <div key={`img-${idx}`} className="gallery-thumbnail-wrapper" onClick={() => setSelectedImage(src)}>
                                                    <img
                                                        src={src}
                                                        alt={`Secret ${idx}`}
                                                        className="gallery-thumbnail"
                                                        style={{ filter: 'saturate(1.1) contrast(1.05)' }}
                                                        onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.style.display = 'none'; }}
                                                    />
                                                </div>
                                            ))}
                                            {secretVideos.length === 0 && hiddenImages.length === 0 && (
                                                <p style={{ gridColumn: '1 / -1', textAlign: 'center', color: '#94a3b8', padding: '20px 0', fontSize: '0.9rem' }}>Архив пуст...</p>
                                            )}
                                        </>
                                    ) : (
                                        galleryImages.map((src, idx) => (
                                            <div key={idx} className="gallery-thumbnail-wrapper" onClick={() => setSelectedImage(src)}>
                                                <img
                                                    src={src}
                                                    alt={`Katifi ${idx}`}
                                                    className="gallery-thumbnail"
                                                    onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.style.display = 'none'; }}
                                                />
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Lightbox portal — rendered directly on document.body */}
            {lightboxPortal}
        </>
    );
};

export default KatifiWidget;
